// extracted by mini-css-extract-plugin
export default {"container":"HDl9o","image":"CidF_","title":"qDTl8","callCenter":"mkm60","button":"Wu_E4"};